<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="fixed z-50 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="
          flex
          items-end
          justify-center
          min-h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:block sm:p-0
        "
      >
        <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
        <div
          class="
            inline-block
            align-bottom
            bg-white
            rounded-lg
            text-left
            overflow-hidden
            shadow-xl
            transform
            transition-all
            sm:my-8 sm:align-middle sm:max-w-lg sm:w-full
          "
        >
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <!-- Error Message -->
            <div
              v-if="errors.length > 0"
              class="
                mb-4
                px-4
                py-3
                rounded-md
                bg-red-600 bg-opacity-20
                flex
                items-center
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-red-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <p class="text-base font-semibold text-red-800 flex-1 px-3">
                {{ errors[0] }}
              </p>
              <button
                @click="$emit('clear')"
                type="button"
                class="focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-red-600"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <!-- End Error Message -->

            <div class="sm:flex sm:items-start">
              <div
                class="
                  mx-auto
                  flex-shrink-0 flex
                  items-center
                  justify-center
                  h-12
                  w-12
                  rounded-full
                  bg-red-100
                  sm:mx-0 sm:h-10 sm:w-10
                "
              >
                <!-- Heroicon name: outline/exclamation -->
                <svg
                  class="h-6 w-6 text-red-600"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3
                  class="text-2xl leading-6 font-medium text-gray-900"
                  id="modal-title"
                >
                  ยืนยันการย้าย Device ออกจากลูกค้า
                </h3>
                <div class="mt-2">
                  <p class="text-base text-gray-500">
                    <slot name="info"
                      >คุณต้องย้ายข้อมูล Device ออกจากลูกค้า?</slot
                    >
                  </p>
                  <p class="text-base text-red-500">
                    S/N: {{ item.hardware_serial_number }}, Model:
                    {{ item.hardware_model.title }}
                  </p>
                </div>
              </div>
            </div>

            <ul class="mt-3">
              <li class="text-base text-red-500 list-disc list-inside">
                ข้อมูล Device Information จะถูกลบทั้งหมด
              </li>
              <li class="text-base text-red-500 list-disc list-inside">
                ข้อมูล Device Config จะถูกลบทั้งหมด
              </li>
            </ul>

            <p class="mt-4 pb-1">
              To confirm move, type
              <span
                class="font-semibold bg-gray-100 text-gray-800 px-1 rounded"
                >{{ item.hardware_serial_number }}</span
              >
              in the text input field.
            </p>

            <input
              v-model="confirmEdit"
              type="text"
              class="
                focus:ring-red-400 focus:border-red-400
                block
                w-full
                shadow-sm
                text-base
                border-gray-300
                rounded-md
                leading-none
                placeholder-gray-400
              "
              :placeholder="item.hardware_serial_number"
            />
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              @click="handleSubmit"
              :disabled="loading || !isConfirmEdit"
              :class="
                loading || !isConfirmEdit
                  ? 'cursor-not-allowed bg-red-300'
                  : 'bg-red-600 hover:bg-red-700'
              "
              type="button"
              class="
                w-full
                inline-flex
                justify-center
                rounded-md
                border border-transparent
                shadow-sm
                px-4
                py-2
                text-base
                font-medium
                text-white
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-red-500
                sm:ml-3 sm:w-auto
              "
            >
              <svg
                v-if="loading"
                class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span class="ml-2">ตกลง</span>
            </button>
            <button
              @click="handleCancel"
              :disabled="loading"
              :class="{ 'cursor-not-allowed': loading }"
              type="button"
              class="
                mt-3
                w-full
                inline-flex
                justify-center
                rounded-md
                border border-gray-300
                shadow-sm
                px-4
                py-2
                bg-white
                text-base
                font-medium
                text-gray-700
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-cyan-500
                sm:mt-0 sm:ml-3 sm:w-auto
              "
            >
              ยกเลิก
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    item: {
      type: Object,
      required: true,
    },

    errors: {
      type: Array,
    },
  },

  data() {
    return {
      confirmEdit: '',
    }
  },

  computed: {
    isConfirmEdit() {
      return this.confirmEdit === this.item?.hardware_serial_number
    },
  },

  methods: {
    handleSubmit() {
      this.confirmEdit = ''
      this.$emit('submit', this.item)
    },
    handleCancel() {
      this.confirmEdit = ''
      this.$emit('cancel')
    },
  },
}
</script>
